<template>
  <div class="userinfo">
    <div class="innerBox">
      <div class="close" @click="close">
        <img src="../assets/close.png" />
      </div>
      <!-- 标题 -->
      <div class="title">
        <span>个人信息</span>
      </div>
      <!-- 表单模块 -->
      <div class="formBox">
        <el-form
          :label-position="labelPosition"
          :rules="rules"
          label-width="80px"
          :model="userInfo"
          ref="ruleForm"
          hide-required-asterisk
        >
          <el-form-item label="用户昵称" prop="nickName">
            <el-input v-model="userInfo.nickName"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="userInfo.realName"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="userInfo.gender">
              <el-radio label="男生"></el-radio>
              <el-radio label="女生"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <div>
              <el-date-picker
                class="date"
                format="yyyy-MM-dd"
                v-model="userInfo.birthday"
                @change="dateChange"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label>
            <el-button
              type="primary"
              round
              icon="el-icon-check"
              @click="submitClick('ruleForm')"
              >确认修改</el-button
            >
          </el-form-item>
        </el-form>
        <div class="userHeadImg">
          <img :src="myHeadImg" @click="updateHeadimg" />
          <span @click="updateHeadimg">修改头像</span>
        </div>
      </div>
      <!-- 水平线 -->
      <div class="line">
        <div></div>
      </div>
      <!-- 家长信息模块 -->
      <div class="parent">
        <div class="parentItem">
          <span class="parentTitle">家长手机</span>
          <span class="content">{{ this.userInfo.mobile }}</span>
        </div>
        <div class="parentItem" v-show="userInfo.parentWechatFlag">
          <span class="parentTitle">家长微信</span>
          <span class="content">{{ this.userInfo.mobile }}</span>
        </div>
        <div class="parentItem" v-show="!userInfo.parentWechatFlag"></div>
        <div class="twoItem">
          <div class="twoC">
            <i class="testImg"></i>
            <span class="twoText" @click="test">设备检测</span>
          </div>
          <div class="twoC">
            <i class="exitImg"></i>
            <span class="twoText" @click="exit">切换账号</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改头像BOX -->
    <div class="updateImgBox" v-show="updateImg">
      <div class="dialogBox">
        <div class="close" @click="closeInner">
          <img src="../assets/close.png" />
        </div>
        <div class="innerTitle">
          <span>修改头像</span>
        </div>
        <div class="chooseImgTxt">选择系统头像</div>
        <div class="systemImgBox">
          <div
            class="systemImg"
            v-for="(item, index) in systemImgList"
            :key="index"
          >
            <img :src="item" @click="updateImgClick(item, index)" />
          </div>
        </div>
        <div class="uploadBox">
          <button @click="show = true">本地上传</button>
        </div>
      </div>
    </div>
    <my-upload
      field="img"
      ref="myUpload"
      @crop-success="cropSuccess"
      v-model="show"
      :width="300"
      :height="300"
      :noSquare="false"
      img-format="png"
    ></my-upload>
    <Test v-show="testBoxShow" @closeTestBox="closeTestBox" />
  </div>
</template>

<script>
import "babel-polyfill";
import myUpload from "vue-image-crop-upload";
import Test from "./test";
export default {
  //注册组件
  components: {
    "my-upload": myUpload,
    Test,
  },
  data() {
    return {
      userInfo: {
        nickName: "", // 昵称
        realName: "", // 姓名
        gender: "", // 性别
        birthday: "", // 生日
        mobile: "", // 手机号
        parentWechatFlag: true,
      },
      myHeadImg: "", // 用户头像
      labelPosition: "right", // 位置：右
      rules: {
        // 表单验证
        nickName: [
          { required: true, message: "请输入你的昵称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入你的名字", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        gender: [
          { required: true, message: "请选择你的性别", trigger: "change" },
        ],
        birthday: [
          {
            type: "string",
            required: true,
            message: "请输入你的生日",
            trigger: "change",
          },
        ],
      },
      systemImgList: [], // 初始的六个头像列表
      show: false, // 是否显示裁剪头像dialog
      updateImg: false, // 是否显示修改头像dialog
      testBoxShow: false,
    };
  },
  mounted() {
    this.axios.get("/v1/api/self").then((res) => {
      this.$refs["ruleForm"].resetFields();
      this.userInfo.realName = res.data.user.name;
      this.userInfo.nickName = res.data.user.nickname;
      this.userInfo.gender = res.data.user.gender;
      this.userInfo.birthday = res.data.user.dateOfBirth;
      this.myHeadImg = res.data.user.avatar;
      this.userInfo.mobile = res.data.user.mobile;
      this.userInfo.parentWechatFlag = res.data.user.wechat ? true : false;
    });
    this.getDefaultImg();
  },
  methods: {
    test() {
      this.testBoxShow = true;
    },
    dateChange(val) {
      this.userInfo.birthday = val.toString();
    },
    updateHeadimg() {
      this.updateImg = !this.updateImg;
    },
    // 系统头像的点击事件
    updateImgClick(item, index) {
      this.myHeadImg = item;
      this.axios.put(`/v1/api/self/avatar/${index + 1}`).then((res) => {
        if (res.data.result === "success") {
          this.message("success", "修改成功~", true);
          this.updateImg = !this.updateImg;
          this.$emit("userrefresh");
        }
      });
    },
    //剪切成功后的回调函数
    cropSuccess(imgDataUrl) {
      this.axios
        .post("/v1/api/self/avatar", {
          avatar: imgDataUrl + "?" + Math.random(),
        })
        .then((res) => {
          if (res.data.result === "success") {
            this.message("success", "本地图片上传成功~");
            this.updateImg = false;
            this.myHeadImg = imgDataUrl;
            this.$emit("userrefresh");
            this.$refs.myUpload.setStep(1);
          }
        });
    },
    close() {
      // 关闭
      this.$emit("close", false);
      this.$refs.ruleForm.resetFields();
      this.getUserInfo();
    },
    closeTestBox(arg) {
      this.testBoxShow = arg;
    },
    closeInner() {
      this.updateImg = false;
    },
    // 点击确认修改按钮
    submitClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios
            .post("/user.json", {
              name: this.userInfo.realName,
              nickname: this.userInfo.nickName,
              dateOfBirth: this.userInfo.birthday,
              gender: this.userInfo.gender,
              mobile: this.userInfo.mobile,
            })
            .then((res) => {
              if (res.data.result === "success") {
                this.message("success", "修改成功~", true);
                this.getUserInfo();
                this.$emit("close", false);
                this.$emit("userrefresh");
              }
            });
        } else {
          return false;
        }
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.axios.get("/v1/api/self").then((res) => {
        this.$refs["ruleForm"].resetFields();
        this.userInfo.realName = res.data.user.name;
        this.userInfo.nickName = res.data.user.nickname;
        this.userInfo.gender = res.data.user.gender;
        this.userInfo.birthday = res.data.user.dateOfBirth;
        this.myHeadImg = res.data.user.avatar;
        this.userInfo.mobile = res.data.user.mobile;
        this.userInfo.parentWechatFlag = res.data.user.wechat ? true : false;
      });
    },
    // 获取初始的六个头像
    getDefaultImg() {
      this.axios.get("/v1/api/self/defaultavatars").then((res) => {
        this.systemImgList = res.data.urls;
      });
    },
    // 封装message
    message(type, message, center = false) {
      this.$message({
        type,
        message,
        center,
      });
    },
    // 切换账号&退出
    exit() {
      this.$confirm("确定要退出这个账号吗？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.axios.post("/signout.json").then((res) => {
          if (res.data.result === "success") {
            this.message("success", "退出成功");
            this.$router.replace("/login");
          } else {
            this.message("error", "退出失败...");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin wh($w: 100%, $h: 100%) {
  width: $w;
  height: $h;
}
@mixin flexCenter() {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin flexColumn() {
  display: flex;
  flex-direction: column;
}
@mixin marginAuto() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
@mixin sizeAndColor($f, $c) {
  font-size: $f;
  color: $c;
}

.userinfo {
  @include wh();
  min-width: 1000px;
  min-height: 700px;
  background-color: rgba(#000000, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
}
.innerBox {
  @include wh(791px, 576px);
  @include marginAuto();
  border-radius: 30px;
  background-color: #fff;
  padding: 15px 25px;
  box-sizing: border-box;
  background-image: url("../assets/bottom.png");
  background-position: left bottom;
  background-size: cover;
}
.close {
  @include wh(94px, 94px);
  position: absolute;
  top: -47px;
  right: -50px;
  cursor: pointer;
  img {
    @include wh();
  }
}
.title {
  @include wh(100%, 50px);
  @include flexCenter();
  span {
    @include sizeAndColor(28px, #fda90a);
  }
}
.formBox {
  @include flexColumn();
  margin: 25px 0;
  padding: 0 20px;
  box-sizing: border-box;
  /deep/ .el-input {
    width: 260px;
  }
  /deep/ .el-input__inner {
    border-radius: 37px;
    border-color: #ffbf19;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background: #ffbf19;
    border-color: #ffbf19;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #ffbf19;
  }
  /deep/ .el-form-item__label {
    padding: 0 24px 0 0;
  }
  .userHeadImg {
    @include wh(200px, 300px);
    @include flexColumn();
    position: absolute;
    right: 20px;
    top: 90px;
    align-items: center;
    img {
      @include wh(150px, 150px);
      border-radius: 50%;
      border: 3px solid rgba(254, 191, 45, 1);
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
    span {
      @include sizeAndColor(14px, #737373);
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }
}
/deep/ .el-button--primary {
  background-color: #ff8f00;
  border-color: #ff8f00;
  &:hover {
    background-color: #fdb826;
    border-color: #fdb826;
  }
}
.line {
  @include wh(100%, 1px);
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  div {
    @include wh(75%, 100%);
    background: #c8c8c8;
  }
}
.parent {
  @include flexColumn();
  padding: 0 20px;
  box-sizing: border-box;
  .parentItem {
    margin: 5px 0;
    .parentTitle {
      margin-right: 15px;
      color: #737373;
    }
    .content {
      color: #5e5e5e;
    }
  }
  .twoItem {
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: flex-end;
    i {
      @include wh(20px, 20px);
      margin-right: 7px;
    }
    i.testImg {
      background-image: url("../assets/test.png");
      background-size: cover;
      transition: all 0.5s ease;
    }
    i.exitImg {
      background-image: url("../assets/exit.png");
      background-size: cover;
      transition: all 0.5s ease;
    }
    .twoC {
      margin: 0 15px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover span {
        color: rgb(231, 173, 47);
      }
    }
    .twoText {
      color: #fff;
    }
  }
}
.systemImgBox {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 0;
  box-sizing: border-box;
  .systemImg {
    width: 33.3%;
    @include flexCenter();
    margin: 13px 0;
    position: relative;
    box-sizing: border-box;
    img {
      @include wh(85px, 85px);
      border-radius: 50%;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
    .activeImg {
      border: 2px solid #ffbf19;
    }
  }
}
.chooseImgTxt {
  text-align: center;
}
.uploadBox {
  @include flexCenter();
  button {
    @include sizeAndColor(17px, #fff);
    padding: 13px 35px;
    border-radius: 24px;
    background-color: #ff8f00;
    border: none;
    outline: none;
    cursor: pointer;
    &:hover {
      background: rgb(211, 120, 0);
    }
  }
}
/deep/ .vicp-crop {
  display: flex;
}
/deep/ .vicp-crop-right {
  flex: 1;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  box-sizing: border-box;
}
// 当前头像盒子
.currentBox {
  padding: 5px 10px;
  background: #ffbf19;
  color: #fff;
  border-radius: 18px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  span {
    font-size: 12px;
  }
}
.updateImgBox {
  @include wh();
  background: rgba(#000000, 0.7);
  position: relative;
  .dialogBox {
    @include wh(527px, 428px);
    @include marginAuto();
    background: #fff;
    border-radius: 30px;
    background-image: url("../assets/bottom.png");
    background-position: left bottom;
    background-size: cover;
    .chooseImgTxt {
      @include wh(100%, 30px);
      text-align: center;
    }
    .innerTitle {
      @include wh(100%, 70px);
      line-height: 70px;
      text-align: center;
      span {
        @include sizeAndColor(22px, #feba28);
      }
    }
  }
}
</style>
